/** Idle session timeout — sign out after this much inactivity. */
export const IDLE_TIMEOUT_MS = 5 * 60 * 60 * 1000;

/** Show a warning toast this long before idle logout. */
export const IDLE_WARNING_MS = 5 * 60 * 1000;

/** Throttle cross-tab activity writes to localStorage. */
export const ACTIVITY_THROTTLE_MS = 30 * 1000;

export const LAST_ACTIVITY_AT_KEY = 'advicelink.lastActivityAt';
export const REMEMBER_ME_KEY = 'advicelink.rememberMe';
export const REMEMBER_ME_EMAIL_KEY = 'advicelink.rememberMeEmail';
export const IDLE_WARNING_TOAST_ID = 'idle-session-warning';

export function getStoredRememberMe() {
  if (typeof window === 'undefined') return true;
  const raw = localStorage.getItem(REMEMBER_ME_KEY);
  if (raw === null) return true;
  return raw === 'true';
}

export function getStoredRememberMeEmail() {
  if (typeof window === 'undefined') return '';
  if (!getStoredRememberMe()) return '';
  return String(localStorage.getItem(REMEMBER_ME_EMAIL_KEY) || '').trim();
}

export function setStoredRememberMeEmail(email) {
  if (typeof window === 'undefined') return;
  const trimmed = String(email || '').trim();
  if (trimmed) {
    localStorage.setItem(REMEMBER_ME_EMAIL_KEY, trimmed);
  } else {
    localStorage.removeItem(REMEMBER_ME_EMAIL_KEY);
  }
}

export function clearLastActivityAt() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(LAST_ACTIVITY_AT_KEY);
}

export function setLastActivityAt(timestamp = Date.now()) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(LAST_ACTIVITY_AT_KEY, String(timestamp));
}

export function readLastActivityAt() {
  if (typeof window === 'undefined') return Date.now();
  const raw = localStorage.getItem(LAST_ACTIVITY_AT_KEY);
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}
